import { FC } from "react";


const ImportantNoticeModal: FC<{ show: boolean; onHide: () => void; }> = ({ show, onHide }): JSX.Element => {
  return (
    <div
      className={`modal modal-lg fade ${show ? 'show show-modal' : ''}`}
      id="importantNoticeModal"
      tabIndex={-1}
      data-bs-backdrop="true"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <p className="modal-title fs-3 text-primary" id="importantNoticeModalLabel">
              **Important Medicare Eligibility Verification Notice**
            </p>
            <button type="button" className="btn-close" aria-label="Close" onClick={onHide}></button>
          </div>
          <div className="modal-body">
            <p>
              EXPAREL Support is currently working through updated CMS HETS registration and attestation requirements
              impacting Medicare eligibility verification transactions.
            </p>
            <p>
              During this period, Medicare eligibility verification may be temporarily unavailable through our standard
              electronic verification process. While EXPAREL Support continues working to restore full connectivity,
              provider offices may need to verify Medicare eligibility and benefits directly using their existing internal
              processes.
            </p>
            <p>
              Please note that EXPAREL Support can continue supporting commercial and secondary coverage verification
              activities during this time.
            </p>
            <p>
              Our team is actively monitoring the situation and working closely with our technology and connectivity
              partners to minimize disruption to patient & provider support services.
            </p>
            <p>
              We appreciate your partnership and patience as the industry works through these CMS changes. Please contact
              our team with any questions at 1-844-462-6225.
            </p>
            <p className="m-0">
              For more information on HETS, please visit:{' '}
              <a href="https://www.cms.gov/data-research/cms-information-technology/hipaa-eligibility-transaction-system-hets/hets-edi-how-enroll" target="_blank" rel="noopener noreferrer">
                https://www.cms.gov/data-research/cms-information-technology/hipaa-eligibility-transaction-system-hets/hets-edi-how-enroll
              </a>
            </p>
          </div>
          <div className="modal-footer">
            <button className="btn btn-primary" onClick={() => onHide?.()}>Close</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportantNoticeModal;
